import { render, staticRenderFns } from "./SmallTimeLine.vue?vue&type=template&id=6120ba35&"
import script from "./SmallTimeLine.vue?vue&type=script&lang=js&"
export * from "./SmallTimeLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports